export default __webpack_public_path__ + "static/media/Bracers of Bestial Rage.8321d790.jpg";